import { WORK_AGE, WORK_CATEGORY } from './work.constants';

/**
 * Maps a work job's stored lookup labels onto the enums the Type of Work form runs on.
 *
 * The form predates the lookup tables and still branches on `WORK_AGE` / `WORK_CATEGORY`
 * constants, while `work_jobs` now points at `project_types` and `construction_work_types`
 * rows whose labels are editable from the masters screen. Matching on substrings rather
 * than exact equality is deliberate: the seeded project-type labels ("Totally New
 * Construction", "Modification, Extension & Addition Work") already differ from the
 * legacy enum text ("New Job", "Existing Job"), so an exact match would silently fail.
 */

/** "Modification, Extension & Addition Work" and "Existing Job" both mean existing work. */
export function workAgeFromProjectType(label: string | null | undefined): string | null {
  if (!label) return null;
  const text = label.toLowerCase();
  if (/existing|modification|extension|addition|renovat|repair/.test(text)) {
    return WORK_AGE.EXISTING;
  }
  return WORK_AGE.NEW;
}

/** Order matters: "Allied + Building Work" contains both words and must be tested first. */
export function workCategoryFromConstructionWorkType(
  label: string | null | undefined
): string | null {
  if (!label) return null;
  const text = label.toLowerCase();
  const hasAllied = text.includes('allied');
  const hasBuilding = text.includes('building');
  if (hasAllied && hasBuilding) return WORK_CATEGORY.ALLIED_BUILDING;
  if (hasBuilding) return WORK_CATEGORY.BUILDING;
  if (hasAllied) return WORK_CATEGORY.ALLIED;
  return null;
}

/** The three labels the Type of Work panel shows read-only when it is bound to a job. */
export interface LockedJobTypes {
  projectType: string | null;
  constructionWorkType: string | null;
  buildingType: string | null;
}
